import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
  id?: string;
  title?: string;
}

const BellIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "currentColor",
  width = 25,
  height = 25,
  id,
  title = "Notifications",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id={id}
    >
      <title>{title}</title>
      <path
        d="M12.5 1.59375C13.4362 1.59389 14.3319 2.08811 14.7725 2.91309C17.3943 3.87547 19.3438 6.33443 19.3438 9.375C19.3438 11.7269 19.9919 14.0106 21.2256 15.9854L21.4795 16.376L21.4893 16.3896L22.3486 17.7178L22.3545 17.7275C22.6894 18.2635 22.7045 18.9021 22.4287 19.417C22.1487 19.9395 21.5979 20.2811 20.9375 20.2812H16.3008C15.9494 22.0578 14.3764 23.4062 12.5 23.4062C10.6235 23.4062 9.05064 22.0578 8.69922 20.2812H4.0625C3.40199 20.2812 2.85141 19.9395 2.57129 19.417C2.29544 18.9021 2.31047 18.2636 2.64551 17.7275L2.65137 17.7178L3.51074 16.3896L3.51953 16.376C4.91815 14.3148 5.65625 11.8835 5.65625 9.375C5.65625 6.3346 7.60499 3.87558 10.2266 2.91309C10.6671 2.08787 11.5636 1.59375 12.5 1.59375ZM10.25 20.2812C10.5666 21.2217 11.4574 21.9062 12.5 21.9062C13.5425 21.9062 14.4334 21.2217 14.75 20.2812H10.25ZM12.5 3.09375C12.005 3.09375 11.6144 3.38947 11.4932 3.75293C11.417 3.98151 11.2348 4.15948 11.0049 4.23145C8.79186 4.92302 7.15625 6.91712 7.15625 9.375C7.15625 12.1732 6.33333 14.8924 4.76953 17.2031L4.77051 17.2041L3.91699 18.5225C3.86156 18.6112 3.87649 18.676 3.89355 18.708C3.90318 18.7259 3.91722 18.7419 3.9375 18.7539C3.95671 18.7652 3.99506 18.7812 4.0625 18.7812H20.9375C21.005 18.7812 21.0434 18.7652 21.0625 18.7539C21.0826 18.7419 21.0969 18.7259 21.1064 18.708C21.1235 18.6759 21.1382 18.6109 21.083 18.5225H21.082L20.2383 17.2178C18.6684 14.9041 17.8438 12.1788 17.8438 9.375C17.8438 6.91728 16.2079 4.92314 13.9951 4.23145C13.7651 4.15956 13.5831 3.98155 13.5068 3.75293C13.3857 3.38951 12.9948 3.09391 12.5 3.09375Z"
        fill={fill}
      />
    </svg>
  );
};

export default BellIcon;
